<template>
    <div>
        <h3>Benutzerdaten übermitteln</h3>
        <form id="setPasswordForm" action="/set-password" method="post" novalidate>
            <!-- Vorbefüllter, nicht änderbarer Benutzername -->
            <div class="input-container">
                <label for="username">Ihre Benutzerkennung:</label>
                <input id="username" disabled="disabled" name="username" type="text" value="max.mustermann@web.de">
            </div>
            <!-- Neues Passwort -->
            <div class="input-container">
                <label for="password">Neues Passwort</label>
                <input
                id="password"
                name="password"
                type="password"
                placeholder="Mindestens 8 Zeichen"
                minlength="8"
                required
                >
            </div>

            <!-- Passwort bestätigen -->
            <div class="input-container">
                <label for="confirm_password">Passwort bestätigen</label>
                <input
                id="confirm_password"
                name="confirm_password"
                type="password"
                placeholder="Geben Sie Ihr Passwort erneut ein"
                minlength="8"
                required
                >
            </div>
            <div id="mismatchError" class="error">Die Passwörter stimmen nicht überein.</div>

            <button type="submit">Passwort speichern</button>
        </form>
    </div>
</template>

<script>

export default {
    components: {
        
    },
    data() {
      return {
        
      }
    },
    methods: {
        
    },
  }

</script>

<style scoped src="@/styles/FirstUserPassword.css">

</style>